import "./Trust.css";
import { motion } from "framer-motion";
import {
  FiCpu,
  FiShield,
  FiBell,
  FiSmartphone,
} from "react-icons/fi";

const cards = [
  {
    icon: <FiCpu />,
    title: "Ağlamayı Anlamlandıran AI",
    text: "Bebeğinizin ağlama, ses ve hareket sinyallerini birlikte değerlendirerek olası ihtiyaçları daha anlaşılır hale getirir.",
  },
  {
    icon: <FiShield />,
    title: "Gizlilik Odaklı Tasarım",
    text: "Ses, görüntü ve oda koşulu gibi hassas veriler mümkün olduğunca cihaz üzerinde işlenir; gereksiz veri aktarımı azaltılır.",
  },
  {
    icon: <FiBell />,
    title: "Anlık Bilgilendirme",
    text: "Uyku, pozisyon veya oda koşullarında dikkat gerektiren bir değişim olduğunda ebeveynlere hızlı bildirim gönderilir.",
  },
  {
    icon: <FiSmartphone />,
    title: "Tek Ekrandan Takip",
    text: "Mobil uygulama üzerinden ses, görüntü, sıcaklık, nem ve uyku bilgileri sade bir akışta takip edilir.",
  },
];

function Trust() {
  return (
    <section className="trust">
      <div className="container">
        <motion.div
          className="trust-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>NEDEN BYBEBEK?</span>

          <h2 className="section-title">
            Daha sakin,
            <br />
            daha anlaşılır ebeveynlik.
          </h2>
        </motion.div>

        <div className="trust-grid">
          {cards.map((card, index) => (
            <motion.article
              className="trust-card"
              key={card.title}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8 }}
              transition={{
                delay: index * 0.08,
                duration: 0.45,
              }}
              viewport={{ once: true }}
            >
              <div className="trust-glow"></div>

              <div className="trust-top">
                <div className="trust-icon">{card.icon}</div>
              </div>

              <h3>{card.title}</h3>

              <p>{card.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Trust;
